import { render, staticRenderFns } from "./goodsSetting.vue?vue&type=template&id=3873551d&scoped=true&"
import script from "./goodsSetting.vue?vue&type=script&lang=js&"
export * from "./goodsSetting.vue?vue&type=script&lang=js&"
import style0 from "./goodsSetting.vue?vue&type=style&index=0&id=3873551d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873551d",
  null
  
)

export default component.exports